import {I18n} from '@aws-amplify/core';

import {FlexiButton,} from '@flexinet/ui-components';

import {useNavigate} from 'react-router-dom';
import {AiOutlineArrowUp} from "react-icons/ai";

export const SimulateButton = ({
                                   buttonText = 'Simulate',
                                   size = 'sm',
                                   onClick,
                               }: {
    buttonText?: string,
    size?: string,
    onClick?: () => void
}) => {
    const navigate = useNavigate();

    if (typeof onClick === 'undefined') {
        onClick = () => {
            navigate('simulate');
        };
    }

    return (
        <FlexiButton
            variant={'outline'}
            onClick={onClick}
            size={size}
            leftSection={<AiOutlineArrowUp/>}
        >
            {I18n.get(buttonText)}
        </FlexiButton>
    );
};
